import { FaInfoCircle } from "react-icons/fa";
import { CSSProperties } from "react";

export const MediaGenerationInfoParagraph = ({
  text,
  customStyle,
}: {
  text: string;
  customStyle?: CSSProperties | null;
}) => {
  return (
    <div
      className="mt-4 flex flex-row items-start"
      style={{ fontSize: "1rem", ...(customStyle || {}) }}
    >
      <FaInfoCircle
        style={{
          color: "rgb(37 99 235)",
          height: "1rem",
          width: "1rem",
          flexShrink: 0,
          marginTop: "0.1rem",
        }}
      />
      <p className="text-blue-600 ml-2 leading-relaxed">{text}</p>
    </div>
  );
};
